import markdownIt from 'markdown-it';

export const md = markdownIt({
  breaks: true,
  html: true,
  xhtmlOut: true,
  linkify: true,
});

// Helper to render markdown and clean up unnecessary paragraph wrapping for inline content
export const renderMarkdown = (text: string): string => {
  const rendered = md.render(text);

  return rendered;
};
